import { changeActivitySelectOperator as changeActivitySelectOperatorDiagram, selectActivityFilterGridData } from '@process-advisor/process-miner/processMiner/processMiner';

export type ActivitySelectOperatorProps = {
    mode?: string;
}

export const changeActivitySelectOperator = ({
    mode,
}: ActivitySelectOperatorProps) => {
    changeActivitySelectOperatorDiagram({ mode });
    selectActivityFilterGridData('');
};
